import { auth } from "../firebase";

// Opens a customer's order page on the website, signed in as this admin.
//
// The website shows an order only to its customer or an admin login, and an
// admin is signed in here, not on maviinci.in. So the new window asks this
// one for the admin's ID token (postMessage), and gets it back only when it
// is the window we opened, on the website's own origin. The token never goes
// in a URL and expires within the hour. Website side:
// suits_website/src/Functions/adminOrderAccess.js
const SITE = "https://www.maviinci.in";
const SITE_ORIGINS = ["https://www.maviinci.in", "https://maviinci.in", "http://localhost:3000"];

export function openOrderOnWebsite(orderId, site = SITE) {
    const w = window.open(`${site}/order/${encodeURIComponent(orderId)}`, "_blank");
    if (!w) return false;
    const onMessage = async (e) => {
        if (!SITE_ORIGINS.includes(e.origin) || e.source !== w) return;
        const d = e.data || {};
        if (d.type !== "maviinci-order-auth-request" || String(d.id) !== String(orderId)) return;
        const user = auth.currentUser;
        if (!user) return;
        try {
            const idToken = await user.getIdToken();
            w.postMessage({ type: "maviinci-order-auth", id: String(orderId), idToken }, e.origin);
        } finally {
            window.removeEventListener("message", onMessage);
        }
    };
    window.addEventListener("message", onMessage);
    // Stop listening if the page never asks (closed, or the customer's own login worked).
    setTimeout(() => window.removeEventListener("message", onMessage), 2 * 60 * 1000);
    return true;
}
